import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Heart } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white/40 relative" data-id="element-304">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-305">
        <FadeIn data-id="element-306">
          <div className="flex justify-center mb-8" data-id="element-307">
            <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center shadow-sm" data-id="element-308">
              <Heart className="text-accent w-8 h-8" data-id="element-309" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-brown-dark mb-8" data-id="element-310">
            Sabemos lo que es sentir que cada noche es una batalla.
          </h2>
          <p className="text-xl text-brown-dark/80 leading-relaxed font-serif italic" data-id="element-311">
            "Has probado dejarlo llorar, seguir rutinas, pero nada se adapta a
            tu cansancio real. Esta guía no es otro consejo genérico: es un
            sistema diseñado para tu realidad."
          </p>
        </FadeIn>
      </div>
    </section>;
}